import { CloseCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { doNotCallRestrictionTypeDataSource } from 'infrastructure/data-sources/do-not-call-restriction-types';
import { useMemo, type FC } from 'react';

import BaseTag from './BaseTag';

import type {
  DoNotCallRestrictionType,
  ClinicDoNotCallRestrictionType,
} from 'infrastructure/enums';

const dataSource = doNotCallRestrictionTypeDataSource({
  withNull: false,
  type: 'clinic',
});

interface Props {
  small?: boolean;
  module?: string;
  restrictionType?:
    | DoNotCallRestrictionType
    | ClinicDoNotCallRestrictionType
    | null;
}

const DoNotCallTag: FC<Props> = ({ small, module, restrictionType }) => {
  const { t } = useTranslation();

  const item = useMemo(
    () => dataSource.findByField('id', restrictionType),
    [restrictionType],
  );

  const { name = '' } = item ?? {};

  const title = module
    ? `${t('labels.doNotCall')}: ${module} ${name}`.trim()
    : t('labels.doNotCall');

  return (
    <BaseTag
      text={title}
      title={title}
      color="red"
      icon={<CloseCircleFilled />}
      dataCy="do-not-call-tag"
      small={small}
    />
  );
};

export default DoNotCallTag;
